import * as Style from "./styles"

const Footer = () => {
  return (
    <Style.FooterContainer />
  )
}

export default  Footer
